import { MasteringStudio } from './features/mastering/MasteringStudio';

export default function App() {
  return <MasteringStudio />;
}
